import React, { useMemo } from 'react';

import { SmlsButton, SmlsHeaderPlaceholder } from '@smiles/smiles-ui-kit-react';
import { Trans, useTranslation } from 'react-i18next';

import { SuspendedAccountWrapperProps } from './types';

const SuspendedAccountWrapper = ({
  children,
  showSecondaryButton = false,
  showSecondaryText = false,
  onPrimaryClik,
  onSecondaryClick,
}: SuspendedAccountWrapperProps) => {
  const { t } = useTranslation('suspended_account');
  const titleI18NKey = useMemo(() => (showSecondaryText ? 'title_of_lock' : 'title'), [showSecondaryText]);
  const subtitleI18NKey = useMemo(() => (showSecondaryText ? 'subtitle_of_lock' : 'subtitle'), [showSecondaryText]);
  const descI18NKey = useMemo(() => (showSecondaryText ? 'description_of_lock' : 'description'), [showSecondaryText]);
  const buttonI18NKey = useMemo(
    () => (showSecondaryText ? 'fill_form_button_of_lock' : 'fill_form_button'),
    [showSecondaryText],
  );
  const descValue = useMemo(() => t(descI18NKey), [descI18NKey]);

  return (
    <div className="smls-suspended-user">
      <SmlsHeaderPlaceholder redirectUrl={window.location.origin} />
      <div className="smls-suspended-user-wrapper">
        <img
          src={`${process.env.PUBLIC_URL}/images/EmailError.svg`}
          alt="mala quebrada"
          id="break"
        />
        <div>
          <h3>{t(titleI18NKey)}</h3>
          <p>
            <Trans t={t} i18nKey={subtitleI18NKey} components={{ bold: <b /> }} />
          </p>
          {descValue && <p>{descValue}</p>}
          <div className="buttons">
            <SmlsButton type="button" onClick={onPrimaryClik} text={t(buttonI18NKey)} />
            {showSecondaryButton && (
              <SmlsButton type="button" onClick={onSecondaryClick} color="hyperlink" text={t('show_phones_button')} />
            )}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default SuspendedAccountWrapper;
